export enum IdmsType {
  InspectionReport,
  ThicknessReport,
  ThicknessLocation,
}
